import AuthService from 'src/services/api/auth.service';
import { useGetUsersFreeIndicatorQuery } from 'src/store/api/onboarding/slice';

export const useSelfSignupUserCheck = () => {
  const userBk = AuthService.getUserBk();

  const {
    data: usersPersonsInfo,
    isLoading,
    isError,
  } = useGetUsersFreeIndicatorQuery(undefined, { skip: !userBk });

  if (isLoading || !userBk) return null;

  if (!usersPersonsInfo || isError) {
    return false;
  }

  const { freeIndicator } = usersPersonsInfo;
  return Boolean(!!freeIndicator && freeIndicator.status);
};
